import styled from 'styled-components';

const CollapseItemStyle = styled.div`
	#collapse-description {
		display: grid;
		grid-template-rows: 0fr;
		overflow: hidden;
		transition: grid-template-rows 0.3s ease-out;

		#inner-wrapper-description {
			overflow: hidden;
		}
	}

	#collapse-item {
		&.active {
			#collapse-description {
				grid-template-rows: 1fr;
			}
		}

		&.disable {
			pointer-events: none;

			#collapse-description {
				grid-template-rows: 0fr;
			}
		}
	}
`;

export default CollapseItemStyle;
